import LogicalInput from '../Estate/Fields/LogicalInput';
import NumberInput from '../Estate/Fields/NumberInput';
import DecimalNumberInput from '../Estate/Fields/DecimalNumberInput';
import TextInput from '../Estate/Fields/TextInput';
import LongTextInput from '../Estate/Fields/LongTextInput';
import SelectiveInput from '../Estate/Fields/SelectiveInput';
import SelectiveMultipleInput from '../Estate/Fields/SelectiveMultipleInput';
import DateInput from '../Estate/Fields/DateInput';
import CommaFormattedInput from '../Estate/Fields/CommaFormattedInput';
import PriceInput from "../Estate/Fields/PriceInput";
import RoomSelect from "../Estate/Fields/RoomSelect";
import { useLocale } from 'use-intl'

const excludeIds = [56];

const InputFactory = ({
                          parameter,
                          addEstate = false,
                          onChange,
                          handleSelectedItems,
                          error,
                          value,
                          disabled,
                          isRange = false,
                          isHomePage = false,
                          verticalRange = false
                      }: any) => {

    const currentLanguage = useLocale()
    const { translations, type, options } = parameter;
    const { name, short_name } = translations[currentLanguage];

    if (excludeIds.includes(parameter.id)) {
        isRange = false;
    }
    if (parameter.id === 38 && isRange) {
        return <PriceInput isHomePage={isHomePage} error={error} addEstate={addEstate} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} verticalRange={verticalRange} isRange={isRange} />;
    }
    if (parameter.id === 11 && isRange) {
        return <RoomSelect error={error} name={name} handleSelectedItems={handleSelectedItems} addEstate={addEstate} isHomePage={isHomePage} onChange={onChange} disabled={disabled} value={value} id={parameter.id} verticalRange={verticalRange} isRange={isRange} />;
    }

    switch (type) {
        case 'Logical':
            return <LogicalInput name={name} addEstate={addEstate} isHomePage={isHomePage} error={error} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} />;
        case 'Number':
            return <NumberInput name={name} addEstate={addEstate} isHomePage={isHomePage} error={error} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} isRange={isRange} verticalRange={verticalRange} />;
        case 'Decimal number':
            return <DecimalNumberInput name={name} addEstate={addEstate} isHomePage={isHomePage} error={error} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} isRange={isRange} verticalRange={verticalRange} />;
        case 'Text (up to 200 char.)':
        case 'Multilingual text (up to 200 char.)':
            return <TextInput name={name} isHomePage={isHomePage} error={error} addEstate={addEstate} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} />;
        case 'Long text':
        case 'Multilingual long text':
            return <LongTextInput name={name} isHomePage={isHomePage} error={error} addEstate={addEstate} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} />;
        case 'Selective':
            if (addEstate) {
                return <SelectiveInput name={short_name} addEstate={addEstate} isHomePage={isHomePage} error={error} shortName={short_name} options={options} onChange={onChange} disabled={disabled} value={value} id={parameter.id} />;
            } else {
                return <SelectiveMultipleInput name={name} addEstate={addEstate} handleSelectedItems={handleSelectedItems} isHomePage={isHomePage} error={error} shortName={short_name} options={options} onChange={onChange} disabled={disabled} value={value} id={parameter.id} />;
            }
        case 'Selective (Multiple)':
            return <SelectiveMultipleInput name={name} addEstate={addEstate} handleSelectedItems={handleSelectedItems} isHomePage={isHomePage} error={error} shortName={short_name} options={options} onChange={onChange} disabled={disabled} value={value} id={parameter.id} />;
        case 'Date':
            return <DateInput name={name} isHomePage={isHomePage} error={error} addEstate={addEstate} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} />;
        case 'Comma formatted':
            return <CommaFormattedInput name={name} isHomePage={isHomePage} error={error} addEstate={addEstate} shortName={short_name} onChange={onChange} disabled={disabled} value={value} id={parameter.id} isRange={isRange} verticalRange={verticalRange} />;
        default:
            return null;
    }
};

export default InputFactory;
